import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TAdminGeneratedTablesData, TAdminSubTabAccessData } from "../../Types";
import { getDateAsObject } from "../../core/et3-date";

export const apiCallGetAdminUsageData = async ({
  startDate,
  endDate
}: {
  startDate: Date;
  endDate: Date;
}): Promise<{
  data: {
    adminSubTabAccessData: TAdminSubTabAccessData;
    adminTableGenerationData: TAdminGeneratedTablesData;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    adminSubTabAccessData: TAdminSubTabAccessData;
    adminTableGenerationData: TAdminGeneratedTablesData;
  }>(`developer/getAdminUsageData`, {
    startDateObject: getDateAsObject(startDate),
    endDateObject: getDateAsObject(endDate)
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { adminSubTabAccessData: [], adminTableGenerationData: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
